// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"a4-z","colorTextValue":"b4-z","swatches":"c4-z","collapseLink":"d4-z","isCollapsed":"e4-z","dropdown":"f4-z","disabled":"g4-z"};